// src/pages/ProtocolPage/hooks/useProtocolPage.js
import { useCallback } from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import {
  getSystemListApi,
  getDiseaseBySystemApi,
  getDiseaseProtocolApi,
  saveRemedyProtocolApi,
} from '../../../../api/auth.api';

const EMPTY_ARRAY = [];
const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const useProtocolPage = (selectedSystemCode) => {
  const toast = useToast();

  /* ===== SYSTEM LIST ===== */
  const { data: systemData, isLoading: isSystemLoading } = useQuery({
    queryKey: ['systems'],
    queryFn: getSystemListApi,
  });

  /* ===== DISEASE BY SYSTEM ===== */
  const { data: diseaseData, isLoading: isDiseaseLoading } = useQuery({
    queryKey: ['diseases', selectedSystemCode],
    queryFn: () => getDiseaseBySystemApi(selectedSystemCode),
    enabled: !!selectedSystemCode && selectedSystemCode !== 'All Sections',
    select: useCallback((res) => res?.data?.result || [], []),
  });

  /* ===== PROTOCOL GENERATION ===== */
  const { mutateAsync: generateProtocol, isPending } = useMutation({
    mutationFn: getDiseaseProtocolApi,
    onError: (error) => {
      console.log('error tos', error);
      toast({
        title: getErrorMessage(error, 'Failed to fetch protocol'),
        status: 'error',
      });
    },
  });

  /* ===== SAVE PROTOCOL ===== */
  const { mutateAsync: saveProtocol, isPending: isSaving } = useMutation({
    mutationFn: saveRemedyProtocolApi,
    onSuccess: () => {
      toast({
        title: 'Protocol saved successfully',
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        title: getErrorMessage(error, 'Failed to save protocol'),
        status: 'error',
      });
    },
  });

  return {
    systems: systemData?.data?.result || EMPTY_ARRAY,
    diseases: diseaseData || EMPTY_ARRAY,
    isSystemLoading,
    isDiseaseLoading,
    generateProtocol,
    isGenerating: isPending,
    remainingBottle1And2Remedy: systemData?.data?.remainingBottle1And2Remedy,
    remainingBottle3And4Remedy: systemData?.data?.remainingBottle3And4Remedy,

    saveProtocol,
    isSaving,
  };
};
